import { DialogM } from "@common/components/alert/dialog/Dialog"
import AvatarM from "@common/components/avatar/AvatarM"
import { BadgeM } from "@common/components/badge/BadgeM"
import FilledButtonM from "@common/components/button/FilledButtonM"
import { Menu3Point } from "@common/components/menu/Menu3Point"
import { ModalM } from "@common/components/modal/ModalM"
import ObjectiveSubjectsBadges, {
    resolveSessionObjective,
} from "@common/components/objectives/ObjectiveSubjectsBadges"
import TextM from "@common/components/text/TextM"
import useLiveKitEventSender from "@common/hooks/livekit/useLiveKitEventSender"
import { useSeenStudentActivity } from "@common/hooks/livekit/useParticipantState"
import { useApiStatus } from "@common/hooks/useApiStatus"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { setTodoActivities } from "@data/redux/actions/data"
import { activitiesService } from "@data/services/activitiesService"
import { liveService } from "@data/services/liveService"
import { liveServiceV2 } from "@data/services/liveServiceV2"
import { schoolAssessmentsService } from "@data/services/schoolAssessmentsService"
import { schoolsService } from "@data/services/schoolsService"
import { hasRole } from "@data/utility/ability"
import { findItemInListWithId } from "@data/utility/dataUtils"
import { supportsNoShowRecovery } from "@data/utility/liveSessionType"
import { useNavigation } from "@react-navigation/native"
import { LinearGradient } from "expo-linear-gradient"
import moment from "moment"
import React, { useContext, useMemo, useRef, useState } from "react"
import {
    Dimensions,
    ScrollView,
    TouchableOpacity,
    Vibration,
    View,
} from "react-native"
import DraggableFlatList from "react-native-draggable-flatlist"
import { FlatList } from "react-native-gesture-handler"
import { ActivityIndicator, IconButton } from "react-native-paper"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import IconButtonM from "../../common/components/button/IconButtonM"
import { getTodaysFinishedActivities } from "../../data/utility/dataUtils"
import { boxedCardBorderStyle } from "../../reviewer/BoxedCardBorderStyle"
import { findClosestNextOccurrence } from "../../student/account/onboarding/LiveRoomCard"
import ChaptersList from "../../student/activity/todo/ChaptersList"
import TodoModal from "../../student/activity/todo/TodoModal"
import { RealizationsListItemContent } from "../../student/organize/list/RealizationsListItemContent"
import GenerateActivityModal from "./GenerateActivityModal"
import { IconTouchableRipple } from "./IconTouchableRipple"
import LiveAvatarM from "./LiveAvatarM"
import SessionSubjectBanner from "./SessionSubjectBanner"
import StudentProfil from "./StudentProfil"
import NextAssessmentWidget from "../../student/schoolAssessments/NextAssessmentWidget"
import SchoolAssessmentsScreen from "../../student/schoolAssessments/SchoolAssessmentsScreen"

const MIN_STUDENTS = 2
const MAX_STUDENTS = 5

export const AdditionalActions = ({ additionalActions, style = {} }) => {
    return (
        <View
            style={{
                flexDirection: "row",
                justifyContent: "flex-end",
                ...style,
            }}
        >
            {additionalActions?.map((a, index) =>
                a?.request ? (
                    a?.requestComponent ? (
                        <React.Fragment key={index}>
                            {a?.requestComponent}
                        </React.Fragment>
                    ) : (
                        <View
                            key={index}
                            style={{
                                width: 42,
                                marginLeft: 5,
                                height: 40,
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <ActivityIndicator
                                key={index}
                                color={a?.loadingColor ?? theme.colors.primary}
                            />
                        </View>
                    )
                ) : a?.additionalComponent ? (
                    <React.Fragment key={index}>
                        {a.additionalComponent}
                    </React.Fragment>
                ) : (
                    <IconTouchableRipple
                        key={index}
                        icon={a?.icon}
                        iconSize={a?.iconSize}
                        label={a?.label}
                        badgeCounter={a?.badgeCounter}
                        disabled={a?.disabled}
                        borderColor={a?.borderColor}
                        color={a?.color}
                        tooltipTitle={a?.tooltipTitle}
                        fontSize={a?.fontSize ?? 12}
                        backgroundColor={a?.backgroundColor}
                        style={{
                            backgroundColor: a?.backgroundColor,
                            marginLeft: 5,
                            borderRadius: a?.borderRadius ?? 0,
                            width: 42,
                            maxWidth: 42,
                            height: "100%",
                            borderColor: a?.borderColor,
                            borderWidth: a?.borderWidth ?? 0,
                        }}
                        onPress={a?.onPress}
                    />
                )
            )}
        </View>
    )
}

function NewStudentsListItem(props) {
    const {
        student,
        index,
        menuItems = [],
        isLoading,
        isLiveMode = false,
        additionalActions = [],
        style,
        isTutor = false,
        withTodo = false,
        studentsNumber,
        byChapter,
        noMessageButton = false,
        onSelectActivity = null,
        onShowAssessments = null,
        selectedActivityId,
        isAssessmentsViewActive = false,
        onBeforeNavigate = null,
    } = props
    const navigation = useNavigation()
    const liveSession = props.currentLiveSession
    // Holiday lives (cours d'été / stage) have no school assessments: there we
    // show the prominent subject banner and hide the control widget. Regular
    // (school-year) lives keep the control banner + the small inline subject
    // chip next to the name. It's one or the other, never both banners.
    const isHolidayLive = ["holiday_workbook", "holiday_course"].includes(
        liveSession?.live_room?.type
    )
    const showSubjectBanner = isLiveMode && !isTutor && isHolidayLive
    const dimensions = useContext(DimensionsContext)
    const studentsPerScreen = Math.max(
        MIN_STUDENTS,
        Math.min(MAX_STUDENTS, studentsNumber)
    )
    const width = withTodo
        ? dimensions.width > 700
            ? (Dimensions.get("window").width - 60) / studentsPerScreen
            : Dimensions.get("window").width - 20
        : dimensions.width - 20

    const [showFinishedActivitiesList, setShowFinishedActivitiesList] =
        useState(true)

    const draggableFlatListRef = useRef()
    const flatListRef = useRef()
    const chaptersListRef = useRef()

    const [isOpen, setOpen] = useState(false)
    const [selectedItemId, setSelectedItemId] = useState(null)
    const [showGenerateModal, setShowGenerateModal] = useState(false)
    const [showStudentModal, setShowStudentModal] = useState(false)
    const [selectionMode, setSelectionMode] = useState(false)
    const [selectedActivities, setSelectedActivities] = useState([])
    const handleShowModal = () => setOpen(!isOpen)
    const todos = student?.todo_activities

    // School assessments modal state
    const [showAssessmentsModal, setShowAssessmentsModal] = useState(false)

    // Selection mode functions
    const toggleSelectionMode = () => {
        setSelectionMode(!selectionMode)
        setSelectedActivities([])
    }

    const handleActivitySelection = (activityId) => {
        if (selectedActivities.includes(activityId)) {
            setSelectedActivities(
                selectedActivities.filter((id) => id !== activityId)
            )
        } else {
            setSelectedActivities([...selectedActivities, activityId])
        }
    }

    const handleDeleteMultiple = () => {
        if (selectedActivities.length === 0) return

        // Check if student is in checkpoint and if one of the archived activities is the current activity
        const isInCheckpoint = props.ongoingCheckpointIds?.includes(student?.id)
        const currentActivityId = props.currentStudentActivity?.[student?.id]
        const isArchivingCurrentActivity =
            selectedActivities.includes(currentActivityId)

        // If student is in checkpoint with one of the archived activities, show confirmation dialog first
        if (isInCheckpoint && isArchivingCurrentActivity) {
            DialogM.show({
                champion: "sam",
                variant: "main",
                text1: `${student?.display_name} est en plein point d'avancement avec Sam sur l'une de ces activités`,
                text2: "Souhaites-tu interrompre la conversation pour archiver ces activités ?",
                buttonText1: "Oui, interrompre et archiver",
                buttonColor1: theme.colors.primary,
                onPress: () => {
                    // Cancel the checkpoint first
                    const activeConversation =
                        student?.conversations?.[
                            student?.conversations?.length - 1
                        ]

                    if (activeConversation?.id) {
                        props.apiRequest(
                            liveService.finishConversation,
                            { conversation_id: activeConversation.id },
                            {
                                interruption_reason: "activity_archived",
                                ended_at: new Date().toISOString(),
                            }
                        )
                    }

                    // Archive the activities
                    props.apiRequest(
                        activitiesService.deleteActivitiesTodo,
                        { student: student?.id },
                        { activity_ids: selectedActivities }
                    )
                },
                buttonText2: "Non",
            })
        } else {
            // No checkpoint, show standard archive dialog
            DialogM.show({
                champion: "zoe",
                text1: `Archiver ${selectedActivities.length} activité${
                    selectedActivities.length > 1 ? "s" : ""
                } de la liste de ${student?.display_name} ?`,
                text2: "Tu pourras les restaurer depuis les activités archivées.",
                buttonText1: "Archiver",
                buttonColor1: theme.colors.primary,
                onPress: () => {
                    // Archive the activities
                    props.apiRequest(
                        activitiesService.deleteActivitiesTodo,
                        { student: student?.id },
                        { activity_ids: selectedActivities }
                    )
                },
                buttonText2: "Annuler",
            })
        }
    }

    const attendanceFlags = liveSession?.attendance_flags?.filter(
        (flag) =>
            flag.user_id === student?.id &&
            moment(flag.date).isSame(moment(), "day")
    )
    const isPaymentBlocked = student?.is_payment_blocked
    const attendanceFlagString = isPaymentBlocked
        ? "Impayé.e"
        : attendanceFlags
              ?.map((attendanceFlag) =>
                  attendanceFlag?.type
                      ? attendanceFlag?.type === "late"
                          ? `Retard signalé ${attendanceFlag?.late_minutes} min`
                          : "Absence signalée"
                      : ""
              )
              ?.join(", ")
    const attendanceFlagColor = isPaymentBlocked
        ? theme.colors.warning
        : attendanceFlags?.some(
                (attendanceFlag) => attendanceFlag?.type === "absent"
            )
          ? theme.colors.error
          : theme.colors.warning

    const closestNextOccurrence = findClosestNextOccurrence([liveSession])

    const temporarilyAdded =
        closestNextOccurrence?.added_users?.find(
            (user) => user.id === student?.id
        ) && supportsNoShowRecovery(liveSession?.live_room)

    const finishedActivities = useMemo(
        () => getTodaysFinishedActivities(student),
        [student]
    )

    // Objective worked in the current live session (shared resolver with
    // ObjectiveSubjectsBadges) — drives the objective strip and scopes the
    // brief modal to the session's objective
    const sessionObjective = useMemo(
        () => resolveSessionObjective(student, props.liveSessionId),
        [student?.pedagogical_objectives, props.liveSessionId]
    )

    const selectedItem = todos
        ?.concat(finishedActivities)
        ?.find((todo) => todo.id === selectedItemId)

    const [deleteOrIndexesRequest, setDeleteOrIndexesRequest] = useState(false)

    const { sendLiveKitData: sendNewTodo } = useLiveKitEventSender()

    const isOnline = !!props.participants?.find((x) => x === student?.id)

    // The avatar on an activity: the one the student has in front of them,
    // not merely open (see `useSeenStudentActivity`).
    const seenStudentActivityId = useSeenStudentActivity(student?.id)
    const currentStudentActivityId = isOnline ? seenStudentActivityId : null

    useApiStatus(
        activitiesService.activityTodoIndexesAsTutor,
        null,
        true,
        () => {
            if (deleteOrIndexesRequest) {
                sendNewTodo(
                    "newTodo",
                    {
                        id: student?.id,
                    },
                    [student?.id]
                )
                setDeleteOrIndexesRequest(false)
            }
        }
    )

    useApiStatus(
        activitiesService.deleteActivitiesTodo,
        null,
        true,
        (response) => {
            const deletedIds = response?.deleted_activity_ids || []
            setSelectedActivities([])
            setSelectionMode(false)
            sendNewTodo(
                "deleteTodo",
                {
                    id: student?.id,
                    activity_ids: deletedIds,
                },
                [student?.id]
            )
        }
    )

    useApiStatus(
        schoolsService.removeStudentFromClassroom,
        "L'élève a bien été retiré de la classe",
        true
    )

    const renderItem = ({ item, drag, isActive }) => {
        const schoolSubject = findItemInListWithId(
            item?.school_subject_id,
            props.schoolSubjects
        )
        const color = schoolSubject?.color
        const isSelected = selectedActivities.includes(item?.id)

        return (
            <TouchableOpacity
                onPress={
                    selectionMode
                        ? () => handleActivitySelection(item?.id)
                        : onSelectActivity
                          ? () => onSelectActivity(item?.id)
                          : () => {
                                setSelectedItemId(item?.id)
                                handleShowModal()
                            }
                }
                onLongPress={() => {
                    if (!selectionMode) {
                        setSelectionMode(true)
                        handleActivitySelection(item?.id)
                    }
                }}
                disabled={isActive}
                style={{
                    backgroundColor:
                        selectionMode && isSelected
                            ? theme.colors.errorLight
                            : theme.colors.white,
                    borderRadius: 10,
                    borderWidth: 1,
                    borderColor: color,
                    marginBottom: 10,
                    width: width - 40,
                    alignSelf: "center",
                    position: "relative",
                }}
            >
                {selectionMode && (
                    <View
                        style={{
                            position: "absolute",
                            top: -6,
                            right: -6,
                            zIndex: 10,
                            width: 20,
                            height: 20,
                            borderRadius: 4,
                            backgroundColor: isSelected
                                ? theme.colors.error
                                : theme.colors.white,
                            alignItems: "center",
                            justifyContent: "center",
                            shadowColor: theme.colors.black,
                            shadowOffset: { width: 0, height: 2 },
                            shadowOpacity: 0.25,
                            shadowRadius: 3.84,
                            elevation: 5,
                            borderWidth: isSelected ? 0 : 2,
                            borderColor: theme.colors.lightMore,
                        }}
                    >
                        {isSelected && (
                            <FontAwesome5
                                name="check"
                                size={10}
                                color={theme.colors.white}
                            />
                        )}
                    </View>
                )}
                <RealizationsListItemContent
                    activity={item}
                    color={selectionMode ? theme.colors.error : color}
                    dragButton={selectionMode ? null : drag}
                    schoolSubject={findItemInListWithId(
                        item?.school_subject_id,
                        props.schoolSubjects
                    )}
                    noBorder={true}
                    noClass={props.user?.id === item?.student_id}
                    todo={true}
                    liveMode={false}
                    tinyMode={studentsPerScreen === 5}
                    custom
                    currentUser={props.user}
                    student={student}
                    highlighted={
                        selectionMode
                            ? isSelected
                            : selectedActivityId === item?.id
                    }
                    highlightColor={
                        selectionMode && isSelected
                            ? theme.colors.errorLight
                            : null
                    }
                    currentActivityId={currentStudentActivityId}
                />
            </TouchableOpacity>
        )
    }

    const request =
        props.deleteCommonActivityTodoRequest ||
        props.getSessionV2Request ||
        props.getCallV2Request ||
        props.getSchoolAssessmentsRequest

    const getLiveSessionApi = liveServiceV2.getLiveSessionV2
    const getCallApi = liveServiceV2.getCallV2

    return (
        <View
            key={index}
            style={{
                ...boxedCardBorderStyle,
                width: width,
                marginBottom: 10,
                marginHorizontal: 5,
                backgroundColor: theme.colors.white,
                borderWidth: 1,
                borderColor: theme.colors.lightMore,
                alignSelf: "stretch",
                borderRadius: 10,
                flex: 1,
                ...style,
            }}
        >
            <View
                style={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingHorizontal: 10,
                    flex: 1,
                }}
            >
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        alignSelf: "stretch",
                        paddingTop: 10,
                    }}
                >
                    <TouchableOpacity
                        style={{}}
                        onPress={() => {
                            if (!isTutor) setShowStudentModal(true)
                        }}
                    >
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "flex-start",
                            }}
                        >
                            {isLiveMode ? (
                                <LiveAvatarM
                                    user={student}
                                    noOutOfApp={noMessageButton}
                                    size={studentsPerScreen === 5 ? 40 : 50}
                                />
                            ) : (
                                <AvatarM
                                    user={student}
                                    style={{ marginRight: 2 }}
                                    size={40}
                                />
                            )}

                            <View
                                style={{
                                    marginLeft: 5,
                                    maxWidth:
                                        width -
                                        73 * (additionalActions?.length ?? 0),
                                }}
                            >
                                <TextM
                                    fontWeight={"SemiBold"}
                                    fontSize={14}
                                    color={theme.colors.primary}
                                >
                                    {student?.display_name}
                                    {temporarilyAdded && " *"}
                                </TextM>
                                <View
                                    style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                    }}
                                >
                                    <TextM
                                        fontWeight={"Medium"}
                                        color={
                                            student?.profile?.class
                                                ? theme.colors.grey
                                                : theme.colors.primary
                                        }
                                        style={{}}
                                        fontSize={11}
                                    >
                                        {student?.profile?.class ?? "Masteur"}
                                    </TextM>
                                    {/* Small inline subject chip — shown everywhere
                                        EXCEPT holiday lives, where the subject banner
                                        below carries the matière instead */}
                                    {!showSubjectBanner && (
                                        <ObjectiveSubjectsBadges
                                            student={student}
                                            liveSessionId={props.liveSessionId}
                                            schoolSubjects={props.schoolSubjects}
                                            style={{ marginLeft: 8 }}
                                        />
                                    )}
                                </View>
                                {!!attendanceFlagString && (
                                    <TextM
                                        fontSize={8}
                                        color={attendanceFlagColor}
                                    >
                                        {attendanceFlagString}
                                    </TextM>
                                )}
                                {!!temporarilyAdded && (
                                    <TextM fontSize={8}>*En rattrapage</TextM>
                                )}
                            </View>
                        </View>
                    </TouchableOpacity>
                    {additionalActions?.length > 0 ? (
                        <AdditionalActions
                            additionalActions={additionalActions}
                            style={{ flex: 1 }}
                        />
                    ) : (
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                        >
                            <IconButton
                                onPress={() => {
                                    props.apiRequest(getLiveSessionApi, {
                                        id: props.liveSessionId,
                                    })
                                    props.apiRequest(getCallApi, {
                                        id: props.liveSessionId,
                                    })
                                    props.apiRequest(
                                        schoolAssessmentsService.getSchoolAssessments,
                                        {},
                                        {},
                                        {
                                            student_id: student?.id,
                                            upcoming: true,
                                        }
                                    )
                                }}
                                iconColor={theme.colors.primary}
                                containerColor={theme.colors.transparent}
                                disabled={request}
                                loading={request}
                                icon={"sync-alt"}
                                style={{ alignSelf: "flex-start" }}
                                size={20}
                            />
                            <Menu3Point
                                menuItems={[
                                    {
                                        icon: "bullseye",
                                        title: "Activités",
                                        onPress: () => {
                                            const nav = () =>
                                                navigation.push("student", {
                                                    studentId: student?.id,
                                                })
                                            onBeforeNavigate
                                                ? onBeforeNavigate(nav)
                                                : nav()
                                        },
                                    },
                                    {
                                        icon: "file-medical-alt",
                                        title: "Rapports de lives",
                                        onPress: () => {
                                            const nav = () =>
                                                navigation.push(
                                                    "live-reports",
                                                    {
                                                        studentId: student?.id,
                                                    }
                                                )
                                            onBeforeNavigate
                                                ? onBeforeNavigate(nav)
                                                : nav()
                                        },
                                    },
                                    {
                                        icon: "archive",
                                        title: "Activités archivées",
                                        onPress: () => {
                                            const nav = () =>
                                                navigation.navigate(
                                                    "archived-activites",
                                                    { studentId: student?.id }
                                                )
                                            onBeforeNavigate
                                                ? onBeforeNavigate(nav)
                                                : nav()
                                        },
                                    },
                                ]}
                                optionStyle={{
                                    width: 200,
                                }}
                            />
                        </View>
                    )}
                </View>

                {/* Holiday lives only: prominent subject banner (no school
                    assessments to show). Tap opens the brief. */}
                {showSubjectBanner && (
                    <SessionSubjectBanner
                        student={student}
                        objective={sessionObjective}
                        schoolSubjects={props.schoolSubjects}
                        onPress={() => setShowStudentModal(true)}
                        style={{
                            width: width - 40,
                            marginTop: 10,
                            marginHorizontal: 10,
                        }}
                    />
                )}

                {/* Next School Assessment Widget — school-year lives only
                    (no school assessments during holiday courses / stages) */}
                {isLiveMode && !isHolidayLive && (
                    <NextAssessmentWidget
                        studentId={student?.id}
                        student={student}
                        onPress={
                            onShowAssessments ||
                            (() => setShowAssessmentsModal(true))
                        }
                        highlighted={isAssessmentsViewActive}
                        style={{
                            width: width - 40,
                            marginTop: 10,
                            marginBottom: 5,
                            marginHorizontal: 10,
                        }}
                    />
                )}

                <View
                    style={{
                        flex: 1,
                    }}
                >
                    {menuItems?.length > 0 ? (
                        !isLoading ? (
                            <Menu3Point menuItems={menuItems} />
                        ) : (
                            <ActivityIndicator color={theme.colors.primary} />
                        )
                    ) : (
                        <></>
                    )}
                    {withTodo && !isTutor && (
                        <>
                            {byChapter ? (
                                <ChaptersList
                                    todos={todos}
                                    schoolSubjects={props.schoolSubjects}
                                    navigation={navigation}
                                    width={width - 40}
                                    style={{ width: width - 40 }}
                                    chaptersListRef={chaptersListRef}
                                />
                            ) : (
                                <DraggableFlatList
                                    data={todos ?? []}
                                    onDragBegin={() =>
                                        !selectionMode && Vibration.vibrate(50)
                                    }
                                    onDragEnd={({ data }) => {
                                        if (selectionMode) return
                                        props.setTodoActivities(data)
                                        setDeleteOrIndexesRequest(true)
                                        if (hasRole(props.user, "student"))
                                            props.apiRequest(
                                                activitiesService.activityTodoIndexesAsStudent,
                                                {},
                                                {
                                                    todo_activities_ids:
                                                        data.map(
                                                            (todo) => todo.id
                                                        ),
                                                }
                                            )
                                        else
                                            props.apiRequest(
                                                activitiesService.activityTodoIndexesAsTutor,
                                                { id: student?.id },
                                                {
                                                    todo_activities_ids:
                                                        data.map(
                                                            (todo) => todo.id
                                                        ),
                                                }
                                            )
                                        Vibration.vibrate(50)
                                    }}
                                    activationDistance={
                                        selectionMode ? 999999 : 0
                                    }
                                    showsHorizontalScrollIndicator={
                                        todos?.length > 0
                                    }
                                    keyExtractor={(item) => item?.id}
                                    contentContainerStyle={{
                                        paddingVertical: 5,
                                    }}
                                    containerStyle={{
                                        flex: 1,
                                    }}
                                    style={{
                                        width:
                                            dimensions.width < 800
                                                ? width - 20
                                                : width,
                                    }}
                                    ref={draggableFlatListRef}
                                    ListEmptyComponent={() => (
                                        <TextM
                                            style={{
                                                textAlign: "center",
                                                marginLeft: 10,
                                                alignSelf: "center",
                                            }}
                                        >
                                            Aucune activité à faire
                                        </TextM>
                                    )}
                                    ListHeaderComponent={() => (
                                        <View>
                                            <View
                                                style={{
                                                    backgroundColor:
                                                        theme.colors.lighter,
                                                    marginHorizontal: 10,
                                                    borderRadius: 10,
                                                    marginTop: 5,
                                                }}
                                            >
                                                <TouchableOpacity
                                                    onPress={() => {
                                                        if (
                                                            finishedActivities?.length >
                                                            0
                                                        ) {
                                                            setShowFinishedActivitiesList(
                                                                !showFinishedActivitiesList
                                                            )
                                                        } else {
                                                            navigation.push(
                                                                "realizations",
                                                                {
                                                                    studentId:
                                                                        student?.id,
                                                                    initialTabRealizations: true,
                                                                }
                                                            )
                                                        }
                                                    }}
                                                    style={{
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "space-between",
                                                        paddingHorizontal: 8,
                                                        paddingVertical: 8,
                                                        borderRadius: 6,
                                                        marginRight: 5,
                                                        marginLeft: 5,
                                                        marginTop: 5,
                                                        marginBottom: 5,
                                                    }}
                                                >
                                                    <View
                                                        style={{
                                                            flexDirection:
                                                                "row",
                                                            alignItems:
                                                                "center",
                                                        }}
                                                    >
                                                        <TextM
                                                            fontSize={12}
                                                            color={
                                                                theme.colors
                                                                    .grey
                                                            }
                                                            fontWeight="Bold"
                                                        >
                                                            FAITES
                                                        </TextM>
                                                        {finishedActivities?.length >
                                                            0 && (
                                                            <BadgeM
                                                                style={{
                                                                    backgroundColor:
                                                                        theme
                                                                            .colors
                                                                            .lighter,
                                                                    color: theme
                                                                        .colors
                                                                        .grey,
                                                                    marginLeft: 5,
                                                                }}
                                                                count={
                                                                    finishedActivities?.length
                                                                }
                                                                size={16}
                                                            />
                                                        )}
                                                    </View>
                                                    <TextM
                                                        fontSize={8}
                                                        color={
                                                            theme.colors.grey
                                                        }
                                                        fontWeight="Bold"
                                                        style={{
                                                            textDecorationLine:
                                                                "underline",
                                                        }}
                                                    >
                                                        {finishedActivities?.length >
                                                        0
                                                            ? showFinishedActivitiesList
                                                                ? "MASQUER"
                                                                : "AFFICHER"
                                                            : "VOIR"}
                                                    </TextM>
                                                </TouchableOpacity>
                                                <FlatList
                                                    data={
                                                        showFinishedActivitiesList
                                                            ? finishedActivities
                                                            : []
                                                    }
                                                    scrollEnabled={false}
                                                    style={{
                                                        overflow: "visible",
                                                    }}
                                                    ref={flatListRef}
                                                    ListFooterComponent={
                                                        showFinishedActivitiesList &&
                                                        finishedActivities?.length >
                                                            0
                                                            ? () => (
                                                                  <View>
                                                                      <FilledButtonM
                                                                          mode={
                                                                              "text"
                                                                          }
                                                                          color={
                                                                              theme
                                                                                  .colors
                                                                                  .primary
                                                                          }
                                                                          style={{
                                                                              width: null,
                                                                              marginBottom: 0,
                                                                          }}
                                                                          labelStyle={{
                                                                              fontSize: 10,
                                                                              height: 16,
                                                                          }}
                                                                          contentStyle={{
                                                                              height: 30,
                                                                          }}
                                                                          onPress={() => {
                                                                              const nav =
                                                                                  () =>
                                                                                      navigation.push(
                                                                                          "realizations",
                                                                                          {
                                                                                              studentId:
                                                                                                  student?.id,
                                                                                              initialTabRealizations: true,
                                                                                          }
                                                                                      )
                                                                              onBeforeNavigate
                                                                                  ? onBeforeNavigate(
                                                                                        nav
                                                                                    )
                                                                                  : nav()
                                                                          }}
                                                                          label="Voir plus"
                                                                      />
                                                                  </View>
                                                              )
                                                            : null
                                                    }
                                                    renderItem={(item) => {
                                                        const userChallenges =
                                                            student?.challenges?.concat(
                                                                student?.history
                                                                    ?.challenges
                                                            )
                                                        const challenge = item
                                                            .item?.challenge_id
                                                            ? findItemInListWithId(
                                                                  item.item
                                                                      ?.challenge_id,
                                                                  userChallenges
                                                              )
                                                            : null
                                                        const schoolSubject =
                                                            findItemInListWithId(
                                                                item?.item
                                                                    ?.school_subject_id,
                                                                props.schoolSubjects
                                                            )
                                                        const color =
                                                            schoolSubject?.color

                                                        return (
                                                            <TouchableOpacity
                                                                style={{
                                                                    marginBottom: 10,
                                                                }}
                                                                onPress={
                                                                    onSelectActivity
                                                                        ? () => {
                                                                              onSelectActivity(
                                                                                  item
                                                                                      .item
                                                                                      ?.id
                                                                              )
                                                                          }
                                                                        : () => {
                                                                              setSelectedItemId(
                                                                                  item
                                                                                      .item
                                                                                      ?.id
                                                                              )
                                                                              handleShowModal()
                                                                          }
                                                                }
                                                            >
                                                                <RealizationsListItemContent
                                                                    color={
                                                                        color
                                                                    }
                                                                    activity={
                                                                        item.item
                                                                    }
                                                                    challenge={
                                                                        challenge
                                                                    }
                                                                    schoolSubject={findItemInListWithId(
                                                                        item
                                                                            ?.item
                                                                            ?.school_subject_id,
                                                                        props.schoolSubjects
                                                                    )}
                                                                    custom
                                                                    noClass={
                                                                        true
                                                                    }
                                                                    style={{
                                                                        position:
                                                                            "relative",
                                                                        opacity: 0.8,
                                                                        borderRadius: 10,
                                                                        borderWidth: 1,
                                                                        borderColor:
                                                                            color,
                                                                        width:
                                                                            width -
                                                                            40,
                                                                        alignSelf:
                                                                            "center",
                                                                    }}
                                                                    currentUser={
                                                                        props.user
                                                                    }
                                                                    student={
                                                                        student
                                                                    }
                                                                    liveMode={
                                                                        false
                                                                    }
                                                                    tinyMode={
                                                                        studentsPerScreen ===
                                                                        5
                                                                    }
                                                                    highlighted={
                                                                        selectedActivityId ===
                                                                        item
                                                                            .item
                                                                            ?.id
                                                                    }
                                                                    currentActivityId={
                                                                        currentStudentActivityId
                                                                    }
                                                                />
                                                            </TouchableOpacity>
                                                        )
                                                    }}
                                                />
                                            </View>
                                            <View
                                                style={{
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    justifyContent:
                                                        "space-between",
                                                    paddingHorizontal:
                                                        !selectionMode ? 8 : 0,
                                                    paddingVertical: 8,
                                                    borderRadius: 6,
                                                    marginLeft: 15,
                                                    marginBottom: 5,
                                                    borderColor:
                                                        theme.colors.lighter,
                                                    paddingTop: 20,
                                                    marginTop: -5,
                                                }}
                                            >
                                                <View
                                                    style={{
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    {selectionMode ? (
                                                        <TouchableOpacity
                                                            onPress={
                                                                toggleSelectionMode
                                                            }
                                                            style={{
                                                                flexDirection:
                                                                    "row",
                                                                alignItems:
                                                                    "center",
                                                                paddingVertical: 4,
                                                                borderRadius: 4,
                                                            }}
                                                        >
                                                            <FontAwesome5
                                                                name="times"
                                                                size={16}
                                                                color={
                                                                    theme.colors
                                                                        .primary
                                                                }
                                                                style={{
                                                                    marginRight: 8,
                                                                }}
                                                            />
                                                            <TextM
                                                                fontSize={12}
                                                                color={
                                                                    theme.colors
                                                                        .primary
                                                                }
                                                                fontWeight="Bold"
                                                            >
                                                                {
                                                                    selectedActivities.length
                                                                }{" "}
                                                                élément
                                                                {selectedActivities.length >
                                                                1
                                                                    ? "s"
                                                                    : ""}{" "}
                                                                sélectionné
                                                                {selectedActivities.length >
                                                                1
                                                                    ? "s"
                                                                    : ""}
                                                            </TextM>
                                                        </TouchableOpacity>
                                                    ) : (
                                                        <>
                                                            <TextM
                                                                fontSize={12}
                                                                color={
                                                                    theme.colors
                                                                        .primary
                                                                }
                                                                fontWeight="Bold"
                                                            >
                                                                À FAIRE
                                                            </TextM>
                                                            <BadgeM
                                                                style={{
                                                                    backgroundColor:
                                                                        theme
                                                                            .colors
                                                                            .primaryLighter,
                                                                    color: theme
                                                                        .colors
                                                                        .primary,
                                                                    marginLeft: 5,
                                                                }}
                                                                count={
                                                                    todos?.length ??
                                                                    "0"
                                                                }
                                                                size={16}
                                                            />
                                                        </>
                                                    )}
                                                </View>
                                                <View
                                                    style={{
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    {todos?.length > 0 && (
                                                        <TouchableOpacity
                                                            onPress={() => {
                                                                if (
                                                                    !selectionMode
                                                                ) {
                                                                    // Enter selection mode and select all
                                                                    setSelectionMode(
                                                                        true
                                                                    )
                                                                    const allActivityIds =
                                                                        todos?.map(
                                                                            (
                                                                                activity
                                                                            ) =>
                                                                                activity.id
                                                                        ) || []
                                                                    setSelectedActivities(
                                                                        allActivityIds
                                                                    )
                                                                } else {
                                                                    // Toggle select all/none
                                                                    if (
                                                                        selectedActivities.length ===
                                                                        todos?.length
                                                                    ) {
                                                                        setSelectedActivities(
                                                                            []
                                                                        )
                                                                    } else {
                                                                        const allActivityIds =
                                                                            todos?.map(
                                                                                (
                                                                                    activity
                                                                                ) =>
                                                                                    activity.id
                                                                            ) ||
                                                                            []
                                                                        setSelectedActivities(
                                                                            allActivityIds
                                                                        )
                                                                    }
                                                                }
                                                            }}
                                                            style={{
                                                                width: 20,
                                                                height: 20,
                                                                borderRadius: 4,
                                                                backgroundColor:
                                                                    selectionMode &&
                                                                    selectedActivities.length ===
                                                                        todos?.length
                                                                        ? theme
                                                                              .colors
                                                                              .error
                                                                        : theme
                                                                              .colors
                                                                              .white,
                                                                alignItems:
                                                                    "center",
                                                                justifyContent:
                                                                    "center",
                                                                borderWidth:
                                                                    selectionMode &&
                                                                    selectedActivities.length ===
                                                                        todos?.length
                                                                        ? 0
                                                                        : 2,
                                                                borderColor:
                                                                    theme.colors
                                                                        .lightMore,
                                                            }}
                                                        >
                                                            {selectionMode &&
                                                                selectedActivities.length ===
                                                                    todos?.length && (
                                                                    <FontAwesome5
                                                                        name="check"
                                                                        size={
                                                                            10
                                                                        }
                                                                        color={
                                                                            theme
                                                                                .colors
                                                                                .white
                                                                        }
                                                                    />
                                                                )}
                                                        </TouchableOpacity>
                                                    )}
                                                </View>
                                            </View>
                                        </View>
                                    )}
                                    ListFooterComponent={() => (
                                        <View
                                            style={{
                                                flexDirection: "row",
                                                alignItems: "center",
                                                alignSelf: "center",
                                                justifyContent: "center",
                                                width: "100%",
                                                paddingHorizontal: 10,
                                                gap: 10,
                                            }}
                                        >
                                            {!selectionMode &&
                                                todos?.length > 0 && (
                                                    <IconButtonM
                                                        onPress={
                                                            toggleSelectionMode
                                                        }
                                                        icon={"archive"}
                                                        size={20}
                                                        style={{
                                                            height: 40,
                                                            width: 40,
                                                            backgroundColor:
                                                                theme.colors
                                                                    .light,
                                                            alignSelf: "center",
                                                            borderRadius: 20,
                                                        }}
                                                        iconColor={
                                                            theme.colors.white
                                                        }
                                                    />
                                                )}
                                            {!selectionMode &&
                                                (() => {
                                                    const materialGenerationAvailable =
                                                        hasRole(
                                                            props.user,
                                                            "tutor"
                                                        )

                                                    const onPress = () => {
                                                        if (
                                                            materialGenerationAvailable
                                                        ) {
                                                            setShowGenerateModal(
                                                                true
                                                            )
                                                        } else {
                                                            navigation.push(
                                                                "new-todo",
                                                                {
                                                                    todoId: null,
                                                                    studentId:
                                                                        student?.id,
                                                                }
                                                            )
                                                        }
                                                    }

                                                    return (
                                                        <TouchableOpacity
                                                            onPress={onPress}
                                                            style={{
                                                                height: 40,
                                                                width: 40,
                                                                alignSelf:
                                                                    "center",
                                                                borderRadius: 20,
                                                                overflow:
                                                                    "hidden",
                                                            }}
                                                        >
                                                            {materialGenerationAvailable ? (
                                                                <LinearGradient
                                                                    colors={[
                                                                        theme
                                                                            .colors
                                                                            .samLight,
                                                                        theme
                                                                            .colors
                                                                            .purple,
                                                                    ]}
                                                                    start={{
                                                                        x: 0,
                                                                        y: 0,
                                                                    }}
                                                                    end={{
                                                                        x: 1,
                                                                        y: 1,
                                                                    }}
                                                                    style={{
                                                                        flex: 1,
                                                                        alignItems:
                                                                            "center",
                                                                        justifyContent:
                                                                            "center",
                                                                        borderRadius: 20,
                                                                    }}
                                                                >
                                                                    <FontAwesome5
                                                                        name="plus"
                                                                        size={
                                                                            20
                                                                        }
                                                                        color={
                                                                            theme
                                                                                .colors
                                                                                .white
                                                                        }
                                                                    />
                                                                </LinearGradient>
                                                            ) : (
                                                                <View
                                                                    style={{
                                                                        flex: 1,
                                                                        backgroundColor:
                                                                            theme
                                                                                .colors
                                                                                .primary,
                                                                        alignItems:
                                                                            "center",
                                                                        justifyContent:
                                                                            "center",
                                                                        borderRadius: 20,
                                                                    }}
                                                                >
                                                                    <FontAwesome5
                                                                        name="plus"
                                                                        size={
                                                                            20
                                                                        }
                                                                        color={
                                                                            theme
                                                                                .colors
                                                                                .white
                                                                        }
                                                                    />
                                                                </View>
                                                            )}
                                                        </TouchableOpacity>
                                                    )
                                                })()}
                                        </View>
                                    )}
                                    renderItem={renderItem}
                                />
                            )}
                        </>
                    )}
                </View>
                {withTodo && !isTutor && selectionMode && (
                    <View
                        style={{
                            borderTopWidth: 1,
                            borderColor: theme.colors.lightMore,
                            backgroundColor: theme.colors.white,
                            paddingHorizontal: 10,
                            paddingVertical: 10,
                            width: "100%",
                            alignItems: "center",
                        }}
                    >
                        <FilledButtonM
                            color={theme.colors.error}
                            style={{ minWidth: 180, maxWidth: 250 }}
                            labelStyle={{ fontSize: 12 }}
                            textColor={theme.colors.white}
                            onPress={handleDeleteMultiple}
                            disabled={
                                selectedActivities.length === 0 ||
                                props.deleteActivitiesTodoRequest
                            }
                            loading={props.deleteActivitiesTodoRequest}
                            icon="archive"
                            label={`Archiver (${selectedActivities.length})`}
                        />
                    </View>
                )}
                {withTodo && !isTutor && (
                    <View
                        style={{
                            borderColor: theme.colors.lightMore,
                            backgroundColor: theme.colors.white,
                            flexDirection: "row",
                            width: "100%",
                            alignItems: "center",
                            height: noMessageButton ? 0 : 36,
                        }}
                    >
                        {!noMessageButton && (
                            <IconTouchableRipple
                                icon={"comment"}
                                iconSize={15}
                                style={{
                                    paddingHorizontal: 10,
                                }}
                                color={
                                    props.currentLiveSession
                                        ?.unread_private_messages_count?.[
                                        student?.id
                                    ] > 0
                                        ? theme.colors.error
                                        : theme.colors.grey
                                }
                                label={"Messages"}
                                horizontal
                                onPress={() => {
                                    navigation.navigate("messages", {
                                        userId: student?.id,
                                    })
                                }}
                                badgeCounter={
                                    props.currentLiveSession
                                        ?.unread_private_messages_count?.[
                                        student?.id
                                    ]
                                }
                            />
                        )}
                    </View>
                )}
            </View>
            {isOpen && (
                <TodoModal
                    isOpen={isOpen}
                    handleShowModal={handleShowModal}
                    item={selectedItem}
                    navigation={navigation}
                    studentId={student?.id}
                    schoolSubject={findItemInListWithId(
                        selectedItem?.school_subject_id,
                        props.schoolSubjects
                    )}
                />
            )}
            {showGenerateModal && (
                <GenerateActivityModal
                    isOpen={showGenerateModal}
                    onClose={() => setShowGenerateModal(false)}
                    student={student}
                    schoolSubjects={props.schoolSubjects}
                />
            )}
            {showStudentModal && (
                <ModalM
                    visible={showStudentModal}
                    withExitButton
                    onDismiss={() => setShowStudentModal(false)}
                    style={{ width: dimensions.width, height: "95%" }}
                >
                    <ScrollView style={{ flex: 1, paddingVertical: 50 }}>
                        <StudentProfil
                            student={student}
                            route={{
                                params: {
                                    studentId: student?.id,
                                    withActions: true,
                                },
                            }}
                            navigation={navigation}
                            noHeader={true}
                            onPressAdditionalActions={() => {
                                setShowStudentModal(false)
                            }}
                            objectiveId={sessionObjective?.id || student?.pedagogical_objective?.id || student?.pedagogical_objectives?.[0]?.id}
                            liveOccurrenceId={isLiveMode ? closestNextOccurrence?.id : undefined}
                            context={isLiveMode ? "in_live" : "pre_session"}
                        />
                    </ScrollView>
                </ModalM>
            )}
            {/* Only show modal when onShowAssessments callback is not provided (non-inline mode) */}
            {showAssessmentsModal && !onShowAssessments && (
                <ModalM
                    visible={showAssessmentsModal}
                    onDismiss={() => setShowAssessmentsModal(false)}
                    style={{ width: dimensions?.width, height: "90%" }}
                >
                    <SchoolAssessmentsScreen
                        studentId={student?.id}
                        student={student}
                        onClose={() => setShowAssessmentsModal(false)}
                        schoolSubjects={props.schoolSubjects}
                    />
                </ModalM>
            )}
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        liveSessionId: state.liveMode?.liveSessionId,
        liveSessions: state.data.currentUser?.object?.live_sessions,
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(
            (x) => x?.id === state.liveMode?.liveSessionId
        ),
        sessions: state.data.currentUser?.object?.sessions,
        participants: state.liveMode?.liveParticipants,
        inCallUsers: state.liveMode?.inCallUsers,
        schoolSubjects: state.data.staticData?.school_subjects,
        getSessionsRequest: state.api.getLiveSession?.request,
        isLive: state.liveMode.isLiveModeEnabled,
        notes: state.data.tutors?.notes,
        getNotesRequest: state.api.getNotes?.request,
        maxTodoActivities: state.data.staticData?.max_todo_activities,
        updatedActivityEventData: state.activity?.updatedActivityEventData,
        activityTemplates: state.data.staticData?.activity_templates,
        getSessionV2Request: state.api.getLiveSessionV2?.request,
        getCallV2Request: state.api.getCallV2?.request,
        deleteCommonActivityTodoRequest:
            state.api.deleteCommonActivityTodo?.request,
        deleteActivitiesTodoRequest: state.api.deleteActivitiesTodo?.request,
        currentStudentActivity: state.liveMode?.currentStudentActivity,
        ongoingCheckpointIds: state.liveMode?.ongoingCheckpointIds,
        getSchoolAssessmentsRequest: state.api.getSchoolAssessments?.request,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    setTodoActivities,
}

export default connect(mapStateToProps, mapDispatchToProps)(NewStudentsListItem)
